import React from "react";
import { glossary } from "../../data/book";
interface TappableTextProps {
  text: string;
  onWord: (word: string, translation: string) => void;
  activeWord?: string;
}
export function TappableText({
  text,
  onWord,
  activeWord
}: TappableTextProps) {
  const parts = text.split(/(\s+)/);
  return <>
      {parts.map((part, i) => {
      const match = part.match(/^([¿¡«"]*)([\p{L}]+)([^\p{L}]*)$/u);
      if (!match) return <React.Fragment key={i} data-id="element-1167" data-mp="3w4i8pnzfgkzv">{part}</React.Fragment>;
      const [, pre, word, post] = match;
      const translation = glossary[word.toLowerCase()];
      if (!translation) return <React.Fragment key={i} data-id="element-1168" data-mp="3n3bp361heu2e">{part}</React.Fragment>;
      const active = activeWord === word.toLowerCase();
      return <React.Fragment key={i} data-id="element-1169" data-mp="3i5a8crrj36u3" data-mpi={i}>
            {pre}
            <button type="button" onClick={() => onWord(word, translation)} className={`focus-ring rounded-md underline decoration-dotted decoration-2 underline-offset-[5px] transition-colors duration-150 ${active ? "bg-accent text-night decoration-transparent" : "decoration-brand/60 hover:bg-brand-tint"}`} data-id="element-1170" data-mp="1lb5piedtxn4k">
              {word}
            </button>
            {post}
          </React.Fragment>;
    })}
    </>;
}